G.UI_StartBoosterButton = function (parentScope, x, y, nr, lvlNr, dailyChallengeLevel, levelInfo, disabled = false) {
	// checking for +3/+5 booster and picking depending on G.IAP
	if (nr === 5 || nr === 6) {
		nr = G.IAP ? 6 : 5;
	}

	Phaser.Group.call(this, game);
	this.state = game.state.getCurrentState();

	this.unlocked = G.saveState.isBoosterUnlocked(nr);

	this.basicBoosterTexture = G.gift.getIconForType("booster#" + nr);
	this.parentScope = parentScope;
	this.x = G.l(x);
	this.y = G.l(y);
	this.nr = nr;
	this.boosterId = 'booster#' + nr.toString();
	this.lvlIndex = lvlNr;
	this.dailyChallengeLevel = dailyChallengeLevel;
	this.returnLevelInfo = levelInfo;	// {layerName: string, args:Array<any>}
	this.disabled = disabled;
	this.onSelected = null;
	if (!Array.isArray(this.returnLevelInfo.args)) {
		this.returnLevelInfo.args = [];
	}

	if (this.unlocked) {

		this.initUnlocked(nr, lvlNr);

		if (G.saveState.data.startBoosterAnim[nr - 5]) {
			G.saveState.data.startBoosterAnim[nr - 5] = false;
			G.saveState.save();
			this.initUlockAnimation();
		}


		//this.initUlockAnimation();
	} else {
		this.img = G.makeImage(0, 0, this.basicBoosterTexture + '_locked', 0.5, this);
	}
	if (this.disabled) {
		this.alpha = 0.5;
	}
};

G.UI_StartBoosterButton.prototype = Object.create(Phaser.Group.prototype);


G.UI_StartBoosterButton.prototype.update = function () {
	if (this.hl) {
		this.hl.angle++;
		this.hl.alpha = game.math.clamp(this.hl.alpha + (this.selected ? 0.05 : -0.05), 0, 0.6);
		this.priceTxt.alpha = game.math.clamp(this.priceTxt.alpha + (this.amount == 0 && !this.selected ? 0.05 : -0.05), 0, 1);
		if (this.disabled) this.priceTxt.alpha = 0;
	}

	for (var i = this.children.length; i--;) {
		this.children[i].update();
	}

};


G.UI_StartBoosterButton.prototype.select = function () {
	if (this.onSelected) this.onSelected(this);
	if (!this.disabled && this.startBoosterConfig && this.startBoosterConfig.select) {
		this.startBoosterConfig.select(this.levelNr, this.boosterNr);
		this.selected = true;
		this.amount--;
		this.amountTxt.setText(this.amount.toString());
		this.setSelectedTexture(true);
	}
};

G.UI_StartBoosterButton.prototype.deselect = function () {
	if (!this.disabled && this.startBoosterConfig && this.startBoosterConfig.deselect) {
		this.startBoosterConfig.deselect(this.levelNr, this.boosterNr);
		this.selected = false;
		this.amount++;
		this.amountTxt.setText(this.amount.toString());
		this.setSelectedTexture(false);
	}
};

G.UI_StartBoosterButton.prototype.setSelectedTexture = function (active) {
	if (this.boosterNr === 5 || this.boosterNr === 7 || this.boosterNr === 8 || this.boosterNr === 6) {
		this.btn.changeTexture(
			this.basicBoosterTexture +
			(active ?
				'_active' :
				''
			));
	}
};


G.UI_StartBoosterButton.prototype.initUnlocked = function (nr, lvlIndex) {

	this.startBoosterConfig = game.state.getCurrentState().startBoosterConfig;

	this.boosterNr = nr;
	this.levelNr = lvlIndex;

	this.hl = G.makeImage(0, 0, 'popup_lighht', 0.5, this);
	this.hl.scale.setTo(0.6);
	this.hl.blendMode = 1;
	this.hl.angle = Math.random() * 360;
	this.hl.alpha = 0;

	this.btn = new G.Button(0, 0, this.basicBoosterTexture, () => {
		if (this.selected) {
			this.deselect();
		} else {
			if (this.amount > 0 || this.disabled) {
				this.select();
				G.sb("onStartBoosterSelectBounce").dispatch();
			} else if (!this.disabled) { // as in, start the buy booster flow if we're not disabled

				if (G.saveState.isEnoughToBuyBooster(this.boosterNr)) {
					const coinCost = G.json.settings['priceOfBooster' + this.boosterNr];
					DDNA.transactionHelper.trackBoosterInventoryPurchase(this.boosterNr, 1, coinCost, lvlIndex + 1);

					OMT.transactionTracking.logInventoryTransactionBegin();
					OMT.transactionTracking.addInventoryChange('boostersReceived', this.boosterNr, 1);
					OMT.transactionTracking.addInventoryChange('coins', 0, -coinCost);
					OMT.transactionTracking.logInventoryTransactionEnd();

					G.saveState.buyBooster(this.boosterNr, lvlIndex);

					this.amount++;
					this.amountTxt.setText(this.amount.toString());
					G.sb("onStartBoosterSelectBounce").dispatch();
				} else {
					if (G.Helpers.pushOutOfCoinsPopUp(false, { event: OMT.platformTracking.Events.OpenShopLvlStart })) {
						let pushLevelPopUp = (optDailyChallengeLevel) => {
							if (optDailyChallengeLevel) {
								G.sb("pushWindow").dispatch(["dailyChallenge"].concat(this.returnLevelInfo.args), false, this.returnLevelInfo.layerName);
							} else {
								G.sb("pushWindow").dispatch(["level"].concat(this.returnLevelInfo.args), false, this.returnLevelInfo.layerName);
							}
						}
						this.parentScope._rh_closeTutorial(false);
						pushLevelPopUp(this.dailyChallengeLevel);
						this.parentScope.closeWindow();
						G.sb("levelWindowClose").dispatch();
					} else {
						this.alpha = 0.5;
						this.btn.inputEnabled = false;
					}
				}

			}
		}
	}, this);
	this.add(this.btn);


	this.selected = false;

	this.amountBg = G.makeImage(-40, -40, 'booster_ammount', 0.5, this);

	this.amount = G.saveState.getBoosterAmount(nr);

	this.amountTxt = new G.Text(-40, -38, this.amount.toString(), G.OMTsettings.elements.UI_StartBoosterButton.amountTxt.style, 0.5, 28);
	this.add(this.amountTxt);

	if (this.disabled) {
		this.amountTxt.visible = false;
		this.amountBg.visible = false;
	}

	this.priceTxt = new G.LabelTextT(
		OMT.language.toLocaleNumber(G.json.settings['priceOfBooster' + this.boosterNr]) + '@coin_1@',
		10, 60, {
			style: "font-purple",
		fontSize: 30,
		scaleStroke: true
	}, 0.5, 100);
	this.add(this.priceTxt);

	if (this.amount > 0 || this.disabled) {
		this.priceTxt.alpha = 0;
	}

	if (this.startBoosterConfig.isSelected(this.levelNr, this.boosterNr) && !this.disabled) {
		this.select();
	}


	if (this.amount == 0 && !game.incentivised() && !G.IAP && G.saveState.getCoins() < G.json.settings['priceOfBooster' + this.boosterNr]) {
		this.alpha = 0.5;
		this.btn.inputEnabled = false;
	}

};

G.UI_StartBoosterButton.prototype.isSelected = function () {
	if (this.startBoosterConfig && this.startBoosterConfig.isSelected) {
		return this.startBoosterConfig.isSelected(this.levelNr, this.boosterNr);
	} else {
		return false;
	}
}


G.UI_StartBoosterButton.prototype.initUlockAnimation = function () {

	this.ignoreChildInput = true;
	this.amountTxt.alpha = 0;
	this.amountBg.alpha = 0;

	var delay = 500;
	//this.amountTxt.setText(0);

	var circle = G.makeImage(0, 0, 'circle', 0.5, this);
	var orgW = circle.width;
	var orgH = circle.height;
	circle.scale.setTo(0);
	circle.blendMode = 1;
	game.add.tween(circle).to({
		width: orgW * 2,
		height: orgH * 2,
		alpha: 0
	}, 600, Phaser.Easing.Cubic.Out, true, delay);

	game.time.events.add(delay, function () {

		G.sfx.match_1.play();

		for (var i = 0; i < 5; i++) {
			var start = G.makeImage(0, 0, 'starPart', 0.5, this);
			start.angle = Math.random() * 360;
			start.velX = Math.random(20) * G.lnf(-20) + G.lnf(10);
			start.velY = Math.random() * G.lnf(-9) - G.lnf(3);
			start.gravity = G.lnf(0.5);
			start.update = function () {
				this.x += this.velX * G.deltaTime;
				this.y += this.velY * G.deltaTime;
				this.angle += this.velX * 0.1;
				this.velX *= 0.99;
				this.velY += this.gravity * G.deltaTime;
				this.alpha -= 0.02;
				if (this.alpha <= 0) this.kill();
			}
		}

		game.add.tween(this.amountTxt).to({ alpha: 1 }, 300, Phaser.Easing.Sinusoidal.Out, true);
		game.add.tween(this.amountBg).to({ alpha: 1 }, 300, Phaser.Easing.Sinusoidal.Out, true);
		this.ignoreChildInput = false;

		//this.amountTxt.setText(G.json.settings.boostersOnStart);

	}, this)


	this.lock = G.makeImage(0, 0, this.basicBoosterTexture + '_locked', 0.5, this);
	game.add.tween(this.lock).to({ alpha: 0 }, 500, Phaser.Easing.Sinusoidal.InOut, true, delay);

};

G.UI_StartBoosterButton.prototype.updateBoosterCount = function () {
	var newAmount = G.saveState.getBoosterAmount(nr);
	if (newAmount !== this.amount) {
		this.amount = newAmount;
		this.amountTxt.setText(this.amount.toString());
	}
};